import styled from 'styled-components'
import Obra from '../imagens/foto1obra.jpg'

export const Main = styled.main`
text-align: center;
`
export const DivTitulo = styled.div`
text-align: center;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background: rgba(0,0,0,1);
background-image: url(${Obra});
background-position: center;
height: 45vh;
box-shadow: inset 0 0 0 200px rgba(0,0,0,0.5);
color: white;
gap: 40px;
h1 {
    font-size: 3rem;
}
h2 {
    font-size: 1.8rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    h1 {
        font-size: 2.5rem;
        margin-top: 1rem;
    }
    h2 {
        font-size: 1.7rem;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
box-shadow: inset 0 0 0 300px rgba(0,0,0,0.5);
}
`
export const SectionEspecificacoes = styled.section`
h2 {
    font-size: 2rem;
}
`
export const DivTabs = styled.div`

display: flex;
justify-content: space-evenly;
align-items: center;
margin-top: 1rem;
button {
    font-size: 1.3rem;
    width: 23%;
    border: none;
    cursor: pointer;
    background-color: transparent;
    transition: 0.4s;
    outline: solid black 2px;
    border-radius: 5px;
}
button:hover {
    transition: 0.1s;
    border-radius: 5px;
    background-color: #2f2f2f;
    color: #fff;
    box-shadow: 0 0 0.5em 0em white;
}
button.active {
    transition: 0.1s;
    border-radius: 5px;
    background-color: #2f2f2f;
    color: #fff;
    box-shadow: 0 0 0.5em 0em white;
}
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
    gap: 10px;
    button {
        width: 100%;
    }
}
`
export const SectionInfoAdicional = styled.section`
background-color: #eaeaea;
margin-top: 2rem;
h2 {
    font-size: 2rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    height: 75vh;
    h2 {
        font-size: 1.8rem;
    }
}
`
export const SectionTextoAdicional = styled.section`
display: flex;
justify-content: space-evenly;
height: 40vh;
div {
    margin-top: 1.5rem;
    width: 45%;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0px 3px 4px 0px #9d9d9d;
    height: 80%;
    h3 {
        font-size: 1.4rem;
    }
    p {
        margin-top: 1rem;
        font-size: 1.1rem;
        text-align: start;
        padding-left: 1rem;
    }

}
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    div {
        width: 85%;
        height: 100%;
    }
    h3 {
        font-size: 1.3rem;
    }
}
`
export const TextoTravamento = styled.div`
p:last-child {
        text-align: center;
        padding-left: 0;
        padding-top: 2rem;
    }
    @media (min-width: 201px) and (max-width: 500px) {
        p:last-child {
        padding-top: 1rem;
    }
    }
`
export const SectionPerguntas = styled.section`
margin-top: 1rem;
h2 {
    font-size: 2rem;
    align-self: center;
}
display: flex;
flex-direction: column;
justify-content: space-around;
align-items: center;
gap: 10px;
height: 80vh;
@media (min-width: 201px) and (max-width: 500px) {
    margin-top: 0.5rem;
    height: 95vh;
    h2 {
        font-size: 1.8rem;
    }
}
`
export const Pergunta = styled.h3`
margin-top: 1rem;
font-size: 1.5rem;
font-weight: 600;
margin-bottom: 0.5rem;
 @media (min-width: 201px) and (max-width: 500px) {
    font-size: 1.3rem;
}
`
export const PerguntaResposta = styled.div`
display: flex;
flex-direction: column;
justify-content: space-around;
width: 55%;
height: 30vh;
box-shadow: 1px 3px 6px 0.5px #9d9d9d;
border-radius: 5px;
p {
    font-size: 1.1rem;
    text-align: start;
    padding-left: 4rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 95%;
    height: 40vh;
    p {
        font-size: 1rem;
        padding-left: 0.5rem;
    }
}
`
export const PerguntaResposta2 = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-around;
height: 30vh;
width: 55%;
box-shadow: 1px 3px 6px 0.5px #9d9d9d;
border-radius: 5px;
gap: 10px;
p {
    font-size: 1.1rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 95%;
    height: 35vh;
    p {
        font-size: 1rem;
    }
}
`
export const TextoPergunta2 = styled.p`
width: 90%;
@media (min-width: 201px) and (max-width: 500px) {
    margin-left: 0;
    width: 95%;
}
`
export const PerguntaSubtitulo = styled.p`
position: relative;
bottom: 0.3rem;
padding-bottom: 0.2rem;
`